module.exports = __webpack_public_path__ + "img/symbol_1.6efefbc9.png";